import { CommonModule } from '@angular/common';
import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { finalize } from 'rxjs';
import { Authentification } from '../../Services/authentification';

@Component({
  selector: 'app-connexion',
  imports: [CommonModule, FormsModule],
  templateUrl: './connexion.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './connexion.css',
})
export class Connexion {
  private auth = inject(Authentification);

  login = '';
  password = '';
  chargement = signal(false);
  erreur = signal('');

  seConnecter() {
    if (!this.login.trim() || !this.password) return;

    this.erreur.set('');
    this.chargement.set(true);
    this.auth
      .logIn(this.login.trim(), this.password)
      .pipe(finalize(() => this.chargement.set(false)))
      .subscribe({
        error: () => {
          this.erreur.set('Identifiants invalides ou service indisponible.');
        },
      });
  }
}
